// Executive header + period toggle (approved HTML component: executive-header).
import type { ReactNode } from 'react';

export type PeriodMode = 'mtd' | 'completed';

export interface ExecutiveHeaderProps {
  mode: PeriodMode;
  onModeChange: (mode: PeriodMode) => void;
  periodNote: string;
  /**
   * W37b: the real summary covers one window (today, UTC day) and has no
   * month-to-date / completed-month comparison, so a real session hides
   * the toggle instead of offering a switch that changes nothing.
   */
  showPeriodToggle?: boolean;
}

export function ExecutiveHeader({
  mode,
  onModeChange,
  periodNote,
  showPeriodToggle = true,
}: ExecutiveHeaderProps): ReactNode {
  return (
    <section className="exec-hero" data-component="executive-header">
      <div>
        <span className="eyebrow">EXECUTIVE LIVE · COMPANY SCORECARD</span>
        <h1>Executive Live</h1>
        <p>Company results, subscription health, sales performance and customer experience.</p>
      </div>
      <div className="period-box">
        <label>{showPeriodToggle ? 'COMPARE PERIOD' : 'PERIOD'}</label>
        {showPeriodToggle ? (
          <div className="period-toggle" role="group" aria-label="Executive comparison period">
            <button
              type="button"
              data-mode="mtd"
              aria-pressed={mode === 'mtd'}
              onClick={() => onModeChange('mtd')}
            >
              Month to date
            </button>
            <button
              type="button"
              data-mode="completed"
              aria-pressed={mode === 'completed'}
              onClick={() => onModeChange('completed')}
            >
              Completed month
            </button>
          </div>
        ) : null}
        <small id="period-note">{periodNote}</small>
      </div>
    </section>
  );
}
